import React from "react"
import "./_style.scss"


import VideoFull from "§/src/components/sections/video-full"
import TileProductReplacement from "§/src/components/atoms/content/tile-content-product-mini"

// Language
import { useTranslation } from 'react-i18next'

const RelatedProductsWithImage = ({ video, products, ...props }) => {

  const { t } = useTranslation()
  const compClassName = "related-products-with-video"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName

  return (
    <div comp={compClassName} className={compClass}>
      <div className={"row"}>
        <div className={"col-lg-12 col-xl-8"}>
          <div className={"rounded-2"}>
            {video && (
              <VideoFull
              data={video}
              className={"no-border-radius mb-0 mb-md-7"}
            />
            )}
          </div>
        </div>
        <div className={"col-lg-12 col-xl-4"}>
          {products && (
            <>
              <p className={"fs-13 fw-semibold text-uppercase mb-2 mt-4 mt-xl-0"}>
                {t('Prodotti correlati')}
              </p>
              <TileProductReplacement data={products} />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default RelatedProductsWithImage
